import { Environment } from '@src/config/environment';
import { secureFetch } from '../secureFetch';
import { ApiError } from './ApiError';

export interface HttpClient {
  fetch<T>(input: RequestInfo, init?: RequestInit): Promise<T | void>;
}

export function createHttpClient(): HttpClient {
  return {
    async fetch<T>(path: string, options: RequestInit) {
      const response = await secureFetch(
        `${Environment.DIRECTUS_API_URL}/${path}`,
        {
          ...options,
          headers: { ...options.headers, Accept: 'application/json' },
          credentials: 'include',
        },
      );

      if (!response.ok) {
        const text = await response.text();
        throw new ApiError(
          `Failed to fetch ${path}: ${text}`,
          path,
          response.status,
        );
      }

      // No Content
      if (response.status === 204) {
        return;
      }
      return response.json() as Promise<T>;
    },
  };
}
